import {useTranslation} from "react-i18next";

const useColumns = (columns = []) => {
  const {t} = useTranslation();

  if (!Array.isArray(columns)) return [];

  return (
    columns?.map(column => ({
      ...column,
      header: typeof column.header === "string" ? t(column.header) : column.header,
    })) || []
  );
};

export default useColumns;
